import { tns } from 'tiny-slider/src/tiny-slider';
var ThreeColumnPageCards = /** @class */ (function () {
    function ThreeColumnPageCards(element) {
        this.threeColumnBlock = element;
        this.layoutType = this.threeColumnBlock.dataset.threeColumnBlock;
        if (this.layoutType === 'slider') {
            this.sliderContainer = element.querySelector('[data-slider]');
            if (this.sliderContainer.childElementCount > 0) {
                // Check if slider contains any elements - initiate slider
                this.initSlider();
            }
        }
    }
    ThreeColumnPageCards.prototype.initSlider = function () {
        var slider = tns({
            container: this.sliderContainer,
            items: 1,
            slideBy: 1,
            loop: false,
            autoplay: false,
            controls: false,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            // @ts-ignore
            prevButton: this.threeColumnBlock.querySelector('.previous-slide-toggle'),
            // @ts-ignore
            nextButton: this.threeColumnBlock.querySelector('.next-slide-toggle'),
            responsive: {
                992: {
                    items: 3,
                    controls: true,
                    nav: true,
                }
            },
        });
    };
    return ThreeColumnPageCards;
}());
var threeColumnPageCardsBlocks = document.querySelectorAll('[data-three-column-block]');
threeColumnPageCardsBlocks.forEach(function (threeColumnBlock) {
    new ThreeColumnPageCards(threeColumnBlock);
});
